module.exports = __webpack_public_path__ + "img/videoResult.72e49efb.png";